import React from 'react'

const InventoryPlanning = () => {
  return (
    <div>InventoryPlanning</div>
  )
}

export default InventoryPlanning